import { useCallback } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/hooks/useAuth';

export function useEventTracking() {
  const { user } = useAuth();

  const trackEvent = useCallback(async (
    eventName: string,
    properties?: Record<string, unknown>
  ) => {
    if (!user) return;

    try {
      await (supabase as any).from('events').insert({
        user_id: user.id,
        event_name: eventName,
        properties: properties || {},
      });
    } catch (err) {
      // Silent fail — analytics should never break the app
      if (import.meta.env.DEV) {
        console.log('[Event]', eventName, properties);
      }
    }
  }, [user]);

  return { trackEvent };
}
